export enum PageTab {
  Conflicts = 'conflicts',
  Policies = 'policies',
  Templates = 'templates'
}
